export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
